import { render, staticRenderFns } from "./companiesList.vue?vue&type=template&id=8f2de76a&scoped=true"
import script from "./companiesList.vue?vue&type=script&lang=js"
export * from "./companiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2de76a",
  null
  
)

export default component.exports